import {
  BreakpointsEnum,
  StandardContainer,
  isBreakpointDown,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';

import LinearGradient from '../LinearGradient';
import TertiaryNavigation, {TertiaryNav} from './TertiaryNavigation';
import {useTheme} from 'styled-components/native';
export interface PageTitleProps {
  title: string;
  navItems?: TertiaryNav[];
  suppressHeaderFooter: boolean;
  activeTab: string;
  updateTab: (tabName: string) => void;
}

const PageTitle: React.FC<PageTitleProps> = ({
  title,
  navItems,
  suppressHeaderFooter,
  updateTab,
  activeTab,
}) => {
  const theme = useTheme();

  const {caesarRewards, white} = theme.colors;
  const breakpoint = useBreakpoint();
  const isLGOrSmaller = isBreakpointDown(breakpoint, BreakpointsEnum.LG);
  const isSmall = isBreakpointDown(breakpoint, BreakpointsEnum.SM);

  return (
    <LinearGradient colors={['#6E0C1D', caesarRewards]}>
      <StandardContainer>
        {suppressHeaderFooter ? (
          navItems && (
            <TertiaryNavigation
              updateTab={updateTab}
              items={navItems}
              activeTab={activeTab}
            />
          )
        ) : (
          <View
            paddingTop={isLGOrSmaller ? 0 : 7}
            paddingBottom={4}
            alignItems={isSmall ? undefined : 'center'}>
            <Text
              textAlign="center"
              accessibilityRole="header"
              accessibilityLevel={1}
              fontFamily="heading"
              fontWeight="700"
              fontSize={isLGOrSmaller ? 6 : '60px'}
              color={white}
              paddingTop={isLGOrSmaller ? 6 : 7}
              paddingBottom={isLGOrSmaller ? 4 : 6}>
              {title.toUpperCase()}
            </Text>
            {navItems && (
              <TertiaryNavigation
                items={navItems}
                updateTab={updateTab}
                activeTab={activeTab}
              />
            )}
          </View>
        )}
      </StandardContainer>
    </LinearGradient>
  );
};

export default PageTitle;
